module.exports = __webpack_public_path__ + "static/couple.22403071.png";


//////////////////
// WEBPACK FOOTER
// ./assets/couple.png
// module id = ./assets/couple.png
// module chunks = 168707334958949